import * as React from "react";
import styled, { css } from "styled-components";
import chunk from "lodash/chunk";

import { CompanyValue } from "../entities";
import { EntityValidationResultMap } from "../../lib/entities/validation";
import CompanyValueGridItem, { GridType } from "./CompanyValueGridItem";
import { media } from "../../common/utils/style";

interface Props {
  companyValues: CompanyValue[];
  editable: boolean;
  validationErrors: EntityValidationResultMap<CompanyValue>;
  onChange?(companyValues: CompanyValue[]): void;
}

class CompanyValueGrid extends React.PureComponent<Props> {
  public onChange = (companyValue: CompanyValue) => {
    const { companyValues, onChange } = this.props;
    onChange!(
      companyValues.map(value => {
        if (value.feature === companyValue.feature) {
          return companyValue;
        }
        return value;
      })
    );
  };

  public render() {
    const { companyValues, validationErrors, editable } = this.props;
    return (
      <Wrapper>
        {chunk(companyValues, 3).map((chunks, index) => {
          const gridType: GridType = index === 0 ? "vertical" : "horizontal";
          const styleProps: StyleProps = { gridType };
          return (
            <Grid key={index} {...styleProps}>
              {chunks.map(value => {
                return (
                  <CompanyValueGridItem
                    key={value.feature}
                    companyValue={value}
                    gridType={gridType}
                    editable={editable}
                    error={validationErrors[value.id]}
                    onChange={this.onChange}
                  />
                );
              })}
            </Grid>
          );
        })}
      </Wrapper>
    );
  }
}

interface StyleProps {
  gridType: GridType;
}

const Wrapper = styled.div`
  display: block;
`;
const Grid = styled.div`
  display: flex;
  ${(props: StyleProps) =>
    props.gridType === "vertical"
      ? css`
          flex-direction: column;
        `
      : css`
          flex-direction: column;
          @media ${media.large} {
            flex-direction: row;
          }
        `};
`;

export default CompanyValueGrid;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValueGrid.tsx